import { Status } from './Resolver';
import { isSegmentSteady, SegmentType } from './Segments';
export var RouteType;

(function (RouteType) {
  RouteType["Switch"] = "switch";
  RouteType["Page"] = "page";
  RouteType["Redirect"] = "redirect";
  RouteType["Plaecholder"] = "placeholder";
})(RouteType || (RouteType = {}));

export function createRoute(url, firstSegment) {
  var segments = [firstSegment].concat(firstSegment.remainingSegments);
  var lastSegment = segments[segments.length - 1];
  var status = lastSegment.status;
  var error; // An error could appear in a mid segment if its content fails to load,
  // and we want to always use the first error available.

  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];

    if (segment.status === Status.Error) {
      error = segment.error;
      status = Status.Error;
    }
  }

  var route = {
    type: lastSegment.type,
    url: url,
    segments: segments,
    firstSegment: segments[0],
    lastSegment: lastSegment,
    isSteady: isSegmentSteady(segments[0]),
    error: error,
    status: status
  };

  if (lastSegment.type === SegmentType.Redirect) {
    route.to = lastSegment.to;
    route.meta = lastSegment.meta;
  }

  if (lastSegment.type === SegmentType.Page) {
    route.title = lastSegment.title;
    route.meta = lastSegment.meta;
    route.content = lastSegment.content;
  }

  return route;
}